import { render } from "./ListeProduitPage.vue?vue&type=template&id=289db272&ts=true"
import script from "./ListeProduitPage.vue?vue&type=script&lang=ts"
export * from "./ListeProduitPage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__